import {action, observable, runInAction} from "mobx";
import type {ITooltipOptions, ITooltipService} from "./tooltip.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IOverlayConsumer} from "../overlay/overlay-consumer.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {TooltipModel} from "./tooltip.model";
import {ITooltipViewModel} from "./tooltip-view-model.interface";
import {ITooltipModel} from "./tooltip-model.interface";
import {OnBoardingTooltipModel} from "./on-boarding-tooltip.model";

export class TooltipService extends ServiceBase implements ITooltipService, IOverlayConsumer {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        services.overlay.registerConsumer(this);
    }


    @observable
    toolTips: ITooltipModel[] = [];

    removeTooltip(tooltip: ITooltipModel): void {
        const index = this.toolTips.findIndex(t => t.id === tooltip.id);
        if(index >= 0) {
            runInAction(() => {
                const toolTipModel = this.toolTips[index];
                this.toolTips.splice(index, 1);
                toolTipModel.dispose();
            });
        }
    }

    onOverlayClicked() {
        //nothing to do here
    }

    getOverlayZIndex(): number | undefined {
        const toolTips = this.toolTips.filter(t => t.showOverlay && t.display);
        if(toolTips.length === 0) {
            return undefined;
        }

        return Math.max(...toolTips.map(t => t.zIndex)) - 1;
    }

    get needsOverlay(): boolean {
        return this.toolTips.some(t => t.display && t.showOverlay);
    }

    private _setDefaultTooltipOptions(options: ITooltipOptions): ITooltipOptions {
        options = {
            showOverlay: true,
            showCloseButton: false,
            closeOnClickOutside: true,
            animated: true,
            ...options};

        return options;
    }

    @action.bound
    createOnBoardingTooltip(options: ITooltipOptions): ITooltipViewModel {
        options = this._setDefaultTooltipOptions(options);
        const tooltipModel = new OnBoardingTooltipModel(this, this.services, options);
        this.toolTips.push(tooltipModel);
        return tooltipModel
    }



    @action.bound
    createTooltip(options: ITooltipOptions): ITooltipViewModel {
        options = this._setDefaultTooltipOptions(options);

        const tooltipModel = new TooltipModel(this, this.services, options);
        this.toolTips.push(tooltipModel);

        return tooltipModel;

    }
}